export class FamiliaProdutoEntity {
  ativado = true;
  descricao = null;

  constructor(familiaProduto) {
    if (familiaProduto.ativado === false) {
      this.ativado = false;
    }
    this.descricao = familiaProduto.descricao;
  }
}
